import { SWRFetcher } from '@commenda/utils';
import useSWR, { KeyedMutator } from 'swr';
import {
  TTransferPricingAccountMapping,
  TTransferPricingPeriodSelection,
} from './types';

export function useTransferPricingAccountMappings(
  policyId: string,
  period?: TTransferPricingPeriodSelection
) {
  const queryString = new URLSearchParams();

  if (policyId) {
    queryString.append('policyId', policyId);
  }

  if (period?.periodStart && (period.periodType || period.periodEnd)) {
    queryString.append('periodStart', period.periodStart);

    if (period.periodType) {
      queryString.append('periodType', period.periodType);
    } else if (period.periodEnd) {
      queryString.append('periodEnd', period.periodEnd);
    }
  }

  const URL = policyId
    ? `transfer-pricing/account-mapping?${queryString.toString()}`
    : null;

  const {
    data,
    error,
    mutate,
  }: {
    data?: {
      accountMappings: TTransferPricingAccountMapping[];
      count: number;
    };
    error?: unknown;
    mutate: KeyedMutator<unknown>;
  } = useSWR(
    URL,
    SWRFetcher({
      method: 'GET',
    })
  );

  return {
    data,
    error,
    mutate,
  };
}
